/**
 * Sanitise a string for safe display — strips HTML tags and trims whitespace.
 * React JSX already escapes interpolated text, but this provides defence-in-depth
 * for user-controlled strings that may be passed to APIs or rendered in toasts.
 */
export function sanitise(input: string): string {
  return input.replace(/<[^>]*>/g, '').trim();
}
